import React, { useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import SavingsOutlinedIcon from "@mui/icons-material/SavingsOutlined";
import { MimshakData } from "../../../interfaces/DTO/mimshakData";
import { CreateRecurringDepositChangeDialog } from "./CreateRecurringDepositChangeDialog";

interface CreateRecurringDepositChangeButtonProps {
  row?: MimshakData;
}

const CreateRecurringDepositChangeButton: React.FC<CreateRecurringDepositChangeButtonProps> = ({ row }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip
        title={row ? `בקשת שינוי הפקדה קבועה - פוליסה ${row.policy_number}` : "בחר שורה כדי לבקש שינוי הפקדה קבועה"}
        placement="top"
      >
        <span>
          <IconButton size="small" onClick={() => setOpen(true)} disabled={!row}>
            <SavingsOutlinedIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>

      {open && row && (
        <CreateRecurringDepositChangeDialog open={open} row={row} onClose={() => setOpen(false)} />
      )}
    </>
  );
};

export default CreateRecurringDepositChangeButton;
